import { render, staticRenderFns } from "./s3uploader.vue?vue&type=template&id=49514e15"
import script from "./s3uploader.vue?vue&type=script&lang=ts"
export * from "./s3uploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49514e15')) {
      api.createRecord('49514e15', component.options)
    } else {
      api.reload('49514e15', component.options)
    }
    module.hot.accept("./s3uploader.vue?vue&type=template&id=49514e15", function () {
      api.rerender('49514e15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/s3uploader/s3uploader.vue"
export default component.exports